<template>
    <div>
        <template v-if="!isApproved">
            <!-- Request Accept or Reject Section -->
            <div v-if="sender" class="approval-request-block">
                <div class="approval-user-profile-img">
                    <span class="active-status approval-user-status"></span>
                    <img :src="senderProfileImage" alt="Active User Info">
                </div>
                <div class="approval-user-name">
                    <p>{{ sender.name }}</p>
                </div>
                <div class="accept-text">
                    <p>{{ $t('screener.chatroom.user.chat.accept.tagline') }}</p>
                </div>
                <div class="approval-actions">
                    <div class="button-group">
                        <button class="btn accept" :class="showHanldeRequestLoader ? 'request-sent' : null " @click="handleMemberRequest('approve')">
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="icon">
                                <path stroke-linecap="round" stroke-linejoin="round" d="M4.5 12.75l6 6 9-13.5" />
                            </svg>
                            {{ $t('screener.chatroom.user.chat.accept.btn.text') }}
                        </button>
                        <button class="btn reject" @click="handleMemberRequest('reject')">
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="icon">
                                <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
                            </svg>
                            {{ $t('screener.chatroom.user.chat.reject.btn.text') }}
                        </button>
                    </div>
                </div>
            </div>
            <!-- Request Accept or Reject Section -->
        </template>
        <template>
            <div class="chat-day"><span>{{ $t('screener.chatroom.chats.today.label') }}</span></div>
            <!-- Chat Messages History Section -->
                <template v-if="chatMessages.length > 0">
                <div class="active-chat-area">
                    <div class="chat-container" ref="messageContainer">
                        <template v-for="privateMessage in chatMessages">
                            <ChatMessageView
                                :key="privateMessage.id"
                                :messageDetail="privateMessage"
                                :senderId="sender.id"
                                @reactToMessage="reactToMessage"/>
                        </template>
                    </div>
                </div>
                </template>

            <!-- Chat Messages History Section -->

            <!-- Send Message Section -->
            <div class="active-chat-send" v-if="isApproved">
                <div class="chat-container">
                    <div class="input-container">
                        <template v-if="sender.profile_image">
                            <img class="user-avatar" :src="sender.profile_image" alt="User Avatar">
                        </template>

                        <input type="text"
                            placeholder="Write message..."
                            v-model="typedMessage"
                            @keyup.enter="sendMessage"
                            class="message-input" />

                            <button class="send-btn" @click="sendMessage">
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
                                <path stroke-linecap="round" stroke-linejoin="round" d="M6 12 3.269 3.125A59.769 59.769 0 0 1 21.485 12 59.768 59.768 0 0 1 3.27 20.875L5.999 12Zm0 0h7.5" />
                                </svg>
                        </button>
                    </div>
                </div>
            </div>
            <!-- Send Message Section -->
        </template>
    </div>
</template>

<script>
import ChatMessageView from '../Presentational/ChatMessageView.vue'
import defaultProfileImage from '@/assets/placeholder.jpg';

export default {
    name :'ChatArea',
    props:{
        isApproved :{
            type: Boolean,
            default:false
        },
        sender: {
            type:Object,
            default:null
        },
        receiver: {
            type:Object,
            default:null
        },
        chatMessages: {
            type:Array,
            default:null
        },
        value: {
            type: String,
            default:null
        }
    },
    computed:{
        senderProfileImage: {
            get(){
                // Step 1: Check who is the Sender of the Message
                if (this.chatMessages[0].senderId === this.receiver.id) {
                    return this.receiver.profile_image || defaultProfileImage;
                }else{
                    return this.sender.profile_image || defaultProfileImage;
                }
            }
        },
        typedMessage : {
            get() {
                return this.value
            },
            set(newValue) {
                this.$emit('input', newValue)
                this.scrollToLastMessage()
            }
        }
    },
    components : {
        ChatMessageView
    },
    watch: {
        // Watch for changes in the messages array
        chatMessages: {
            handler(newMessages, oldMessages) {
                // Check if the length has increased
                if (newMessages.length > oldMessages.length) {
                    this.scrollToLastMessage()
                }
            },
            deep: true, // Ensures nested changes are detected
        },
    },
    data() {
        return {
            showHanldeRequestLoader:false,
            message:null
        }
    },
    created() {
        this.scrollToLastMessage()
    },
    methods:{
        handleMemberRequest(type) {
            console.log("Me clicked");

            this.$emit('manageProfileApproval', type)
        },
        sendMessage() {
            if (this.value) {
                this.$emit('sendMessage')
            }
        },
        scrollToLastMessage() {
            this.$nextTick(() => {
                if (this.isApproved) {
                    if ('lastElementChild' in this.$refs.messageContainer) {
                        const lastChildElement = this.$refs.messageContainer.lastElementChild;
                        lastChildElement.scrollIntoView({
                            behavior: 'smooth',
                        });
                    }
                }
            })

        },
        reactToMessage(reactionObject) {
            this.$emit('reactionToMessage', reactionObject)
        }
    }
}
</script>

<style lang="scss" scoped>

</style>
